import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="google-form"
export default class extends Controller {
  static targets = ['form', 'status', 'submitButton'];
  static values = {
    action: String,
    pageHistory: { type: String, default: '0' }
  };

  connect() {
    this.prefillFromUrl();
  }

  // Supports Google Forms-style prefill: ?entry.123456=ORDER_ID
  // Same pattern as Setting.feedback_promo_form_url + appended public_id.
  prefillFromUrl() {
    if (!this.hasFormTarget) return;

    const params = new URLSearchParams(window.location.search);
    params.forEach((value, key) => {
      if (!key.startsWith('entry.') || !value) return;

      const fields = this.formTarget.querySelectorAll(`[name="${CSS.escape(key)}"]`);
      if (!fields.length) return;

      fields.forEach((field) => {
        if (field.type === 'radio' || field.type === 'checkbox') {
          field.checked = field.value === value;
          return;
        }

        field.value = value;
      });
    });
  }

  async submit(event) {
    event.preventDefault();

    if (!this.hasFormTarget) return;

    const form = this.formTarget;
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    this.setSubmitting(true);
    this.hideStatus();

    try {
      // Google Forms expects urlencoded bodies; multipart FormData is unreliable.
      // Multi-page forms also need pageHistory covering every section, otherwise
      // only answers from the first page are stored.
      const body = new URLSearchParams(new FormData(form));
      if (!body.has('pageHistory')) {
        body.set('pageHistory', this.pageHistoryValue || '0');
      }
      if (!body.has('fvv')) {
        body.set('fvv', '1');
      }

      await fetch(this.actionValue || form.action, {
        method: 'POST',
        mode: 'no-cors',
        body
      });

      form.reset();
      this.showStatus(this.statusMessage('success'), false);
    } catch (_error) {
      this.showStatus(this.statusMessage('error'), true);
    } finally {
      this.setSubmitting(false);
    }
  }

  setSubmitting(isSubmitting) {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = isSubmitting;
    }
  }

  showStatus(message, isError) {
    if (!this.hasStatusTarget) return;

    this.statusTarget.hidden = false;
    this.statusTarget.textContent = message;
    this.statusTarget.classList.toggle('google-form__status--error', isError);
  }

  hideStatus() {
    if (!this.hasStatusTarget) return;
    this.statusTarget.hidden = true;
    this.statusTarget.textContent = '';
  }

  statusMessage(kind) {
    return this.element.dataset[`googleForm${kind[0].toUpperCase()}${kind.slice(1)}Message`] ||
      (kind === 'success' ? 'Submitted.' : 'Submission failed.');
  }
}
